import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { ChargeObj } from "../../utils/types";

const initialState: ChargeObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getCallEmailsData = createAsyncThunk(
  "loans/CallEmailsData",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const communicationSlice = createSlice({
  name: "communications",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCallEmailsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCallEmailsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getCallEmailsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default communicationSlice.reducer;
